import { render, staticRenderFns } from "./IncidentsTypesTable.vue?vue&type=template&id=299fb77e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./IncidentsTypesTable.vue?vue&type=script&lang=js"
export * from "./IncidentsTypesTable.vue?vue&type=script&lang=js"
import style0 from "./IncidentsTypesTable.vue?vue&type=style&index=0&id=299fb77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299fb77e",
  null
  
)

export default component.exports